import { i18n } from '@/plugins/i18n'
import { StatusColumn } from './../components'
import { PspColumn } from './../components'
import { pspRequestTypeStr } from '@/constants/pspRequestStatus'

const statusTemplate = (row, index, datatable) => {
    let template = new StatusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

const pspTemplate = (row, index, datatable) => {
    let template = new PspColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 40,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'ref.farsi_name',
        title: i18n.t('label.ref_farsi_name'),
        sortable: false,
        template: (row) => {
            return '<a href="/gateway/gateway-pf/' + row.ref.id + '/details">'+row.ref.farsi_name+'</a>'
        },
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'user_full_name',
        title: i18n.t('label.User_full_name'),
        sortable: false,
        template: (row) => {
            return '<a href="/users/' + row.user_hashid + '/details">'+row.user_full_name+'</a>'
        },
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'ref.website_address',
        title: i18n.t('label.website_address'),
        sortable: false,
        width: 130,
        textAlign: 'center',
    },
    {
        field: 'ref.id',
        title: i18n.t('label.ref_id'),
        sortable: false,
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'terminal_number',
        title: i18n.t('label.terminal_number'),
        sortable: true,
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'psp',
        sortable: true,
        title: i18n.t('label.psp'),
        template: (row, index, datatable) => {
            return pspTemplate(row, index, datatable)
        },
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        sortable: true,
        title: i18n.t('label.created_at'),
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'type',
        sortable: true,
        title: i18n.t('label.type'),
        template: (row) => {
            return '<span>' + (pspRequestTypeStr.get(row.type) || '') + '</span>'
        },
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('label.status'),
        template: (row, index, datatable) => {
            return statusTemplate(row, index, datatable)
        },
        width: 90,
        textAlign: 'center',
    },
]